import { Routes } from '@angular/router';

export const FIELDSUPPLIER_ROUTES: Routes = [
  {
    path: 'channels/field-suppliers/view-edit/:fieldSupplierId',
    loadComponent: () =>
      import('./field-supplier-view-edit/field-supplier-view-edit.component').then(
        (com) => com.FieldSupplierViewEditComponent
      ),
    title: 'View/Edit Field Supplier',
  },
  {
    path: 'channels/field-suppliers/add',
    loadComponent: () =>
      import('./field-supplier-add/field-supplier-add.component').then(
        (com) => com.FieldSupplierAddComponent
      ),
    title: 'Add Field Supplier',
  },
  {
    path: 'channels/field-supplier-country-methodologies/:fieldSupplierId/field-supplier',
    loadComponent: () =>
      import('./field-supplier-country-methodology/field-supplier-country-methodology.component').then(
        (com) => com.FieldSupplierCountryMethodologyComponent
      ),
    title: 'Field Supplier Countries and Methodologies',
  },
  {
    path: 'channels/field-supplier-country-methodologies/:countryId/country',
    loadComponent: () =>
      import('./field-supplier-country-methodology/field-supplier-country-methodology.component').then(
        (com) => com.FieldSupplierCountryMethodologyComponent
      ),
    title: 'Country Field Suppliers and Methodologies',
  },
  {
    path: 'channels/field-supplier-country-methodologies/add',
    loadComponent: () =>
      import('./field-supplier-country-methodology/supplier-sample-add/supplier-sample-add.component').then(
        (com) => com.SupplierSampleAddComponent
      ),
    title: 'Add Supplier Sample Definition',
  },
  {
    path: 'channels/field-supplier-country-methodologies/view-edit/:supplierSampleId',
    loadComponent: () =>
      import('./field-supplier-country-methodology/supplier-sample-view-edit/supplier-sample-view-edit.component').then(
        (com) => com.SupplierSampleViewEditComponent
      ),
    title: 'Edit Supplier Sample Definition',
  },
];
